/**
 * Rollout flags: the `settings.json` booleans read through `useFlag()`, which an admin can
 * override per session (⊞ panel) and roll out to a parent cohort (System → Flag Cohorts).
 * Plain config read directly as `settings.x` does not belong here.
 */
export const ROLLOUT_FLAGS: ReadonlyArray<{ flag: string; label: string }> = [
  { flag: 'parentPickupDetails', label: 'Pickup Details for Parents' },
  { flag: 'enableCardAddFunds', label: 'Card Add Funds (BHCS Cash)' },
];
